import { createReducer, on } from "@ngrx/store";
import { ImpersonationMeta } from "@niko-crm/ui";
import { LoggedUserActions } from "./logged-user.actions";

export interface LoggedUserData {
  /**
   * `''` when there is no real `users` row backing the session — the
   * SuperAdmin and N>1-membership placeholders both dispatch `loginSuccess`
   * with `user.id: ''` (see `logged-user.effects.ts`). Consumers that need
   * "assigned to me" MUST guard on the empty id and issue no request rather
   * than an unfiltered one (D9, BR-PROSPECT-10).
   */
  userId: string;
  name: string;
  email: string;
  lastname: string;
  fullname: string;
  permissions: string[];
  isSuperAdmin: boolean;
  tenantName: string;
  /**
   * Set while the session runs under impersonation (BR-AUTH-03). The rest of
   * the slice then describes the IMPERSONATED user — the actor only lives here.
   */
  impersonation: ImpersonationMeta | null;
  error?:string;
}

const initialState: LoggedUserData = {
  userId: '',
  name: '',
  lastname: '',
  fullname: '',
  email: '',
  permissions: [],
  isSuperAdmin: false,
  tenantName: '',
  impersonation: null,
  error: ''
};

export const loggedUserReducer = createReducer(
  initialState,
  on(LoggedUserActions.loginSuccess, (_state, { user, permissions, isSuperAdmin, tenantName, impersonation }) => ({
    userId: user.id ?? '',
    name: user.name,
    lastname: user.lastname,
    fullname: isSuperAdmin ? user.email : `${user.name} ${user.lastname}`,
    email: user.email,
    permissions,
    isSuperAdmin: isSuperAdmin ?? false,
    tenantName: tenantName ?? user.tenant?.name ?? '',
    impersonation: impersonation ?? null,
  })),
  on(LoggedUserActions.selectTenantSuccess, (state, { tenantName }) => ({
    ...state,
    tenantName,
  })),
  on(LoggedUserActions.errorSettingUserLoggedData, (state, { error }) => ({
    ...state,
    error,
  })),
  on(LoggedUserActions.logoutSuccess, () => initialState),
);
